import { render, staticRenderFns } from "./DocTemplateGenerateV2.vue?vue&type=template&id=d3a683d4&"
import script from "./DocTemplateGenerateV2.vue?vue&type=script&lang=ts&"
export * from "./DocTemplateGenerateV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports